import React from 'react'

import Tag, { TagProps, TagSize } from '~/components/atoms/tag/Tag'
import TagListWrap from '~/components/atoms/tag/TagListWrap'

interface TagListProps {
  list: TagProps[]
  vertical?: boolean
  size?: TagSize
}

const TagList = ({list, vertical = false, size = TagSize.SMALL}: TagListProps) => {
  return (
    <TagListWrap vertical={vertical}>
      {list.map((tag: TagProps, index: number) =>
        <Tag key={index} text={tag.text} color={tag.color} link={tag.link} size={size}/>
      )}
    </TagListWrap>
  )
}

export default TagList